/*
 * TreatmentPlan Messages
 *
 * This contains all the text for the TreatmentPlan component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.TreatmentPlan";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the TreatmentPlan component!",
  },
  selectResult: {
    id: `${scope}.selectResult`,
    defaultMessage: "Select treatment plan",
  },
  above: {
    id: `${scope}.above`,
    defaultMessage: "above",
  },
  below: {
    id: `${scope}.below`,
    defaultMessage: "below",
  },
  skipTreatment: {
    id: `${scope}.skipTreatment`,
    defaultMessage: "Skip treatment",
  },
  mustSelectEndProduct: {
    id: `${scope}.mustSelectEndProduct`,
    defaultMessage: "And end product must be selected",
  },
  editTreatment: {
    id: `${scope}.editTreatment`,
    defaultMessage: "Edit date",
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: "Product",
  },
  upperJaw: {
    id: `${scope}.upperJaw`,
    defaultMessage: "Upper jaw",
  },
  lowerJaw: {
    id: `${scope}.lowerJaw`,
    defaultMessage: "Lower jaw",
  },
});
